import React , {useState} from 'react';
import './BridalService.scss';
import imgPlanning from "../../assets/photos/MesureWoman2.jpg"
import imgDesign from "../../assets/photos/CustomDesign.jpg"
import imgCreate from "../../assets/photos/AlterationCreate.jpg"
import imgWear from "../../assets/photos/WomanDress.jpg"
import { Helmet } from "react-helmet-async";
const imgCustom = [
      { 
        id: 1, 
        src: imgPlanning, 
        title: "Consultation & Planning", 
        description: "We discuss your vision, take measurements, and explore fabric and design options to ensure a perfect fit." 
      },
      { 
        id: 2, 
        src: imgDesign, 
        title: "Custom Design", 
        description: "Our experts sketch and refine the details, ensuring the alteration enhances style, comfort, and functionality." 
      },
      { 
        id: 3, 
        src: imgCreate, 
        title: "Precision Crafting",  
        description: "Skilled hands bring your design to life, carefully tailoring every stitch for a flawless and high-quality finish." 
      },
      { 
        id: 4, 
        src: imgWear, 
        title: "The Perfect Fit", 
        description: "Try on your custom piece, make any final adjustments, and step out with confidence in your one-of-a-kind look." 
      },
    ];
    
const contentFaqs = [
        {
            question: "How long does it take to make a custom garment?",
            answer: 
                "The process typically takes 3-6 weeks, depending on the design complexity. Rush orders may be available."
        },
        {
            question: "How much does a custom-made outfit cost?",
            answer: 
                "Pricing varies based on fabric, design, and craftsmanship. We provide a detailed quote after the initial consultation."
        },
        {
            question: "Does the store have fabrics available?",
            answer: 
                "Unfortunately, we don’t have any at the moment, so you’ll need to bring your own."
        },
        {
            question: "What should I expect during the consultation?",
            answer: 
                "We'll discuss your vision, take measurements, and review your fabric and design options to create a unique piece tailored just for you."
        },
        {
            question: "How many fittings will I need?",
            answer: 
                "Most custom garments require 2-3 fittings to ensure the perfect fit and allow for adjustments."
        },
        {
            question: "Do you create both casual and formal wear?",
            answer: 
                "Yes! We design everything from everyday outfits to gowns, and special occasion wear."
        }
    ];


const CustomService = () => {
  const [selectedImage, setSelectedImage] = useState(imgCustom[1]);
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="content-Bridal">
      <Helmet>
        <title>Custom Tailoring | Bespoke Clothing | Cooper City, FL</title>
        <meta name="description" content="Design your perfect fit with our custom tailoring services. Bespoke clothing made to your measurements in Cooper City, Florida." />
        <link rel="canonical" href="https://www.alterationsbysdenka-paola.com/services/custom" />
      </Helmet>
        <div className='bridal_head'>
          <h1>Tailored to Perfection</h1>
          <p>Expert alterations designed for the perfect fit. From consultation to final touches, we bring your vision to life with precision and style.</p>
        </div>
      <div className="image-grid">
        {imgCustom.map((image) => (
          <div key={image.id} className="image-container">
            <img src={image.src} alt={image.title} className="image" />
            <div className="overlay">
                <h2>{image.title}</h2>
                <strong><p>{image.timeNeeded}</p></strong>
                <p>{image.description}</p>
              </div>
          </div>
        ))}
      </div>
      <div className="image-selector_mobile">
        <div className="image-container">
          {imgCustom.map((image) => (
            <div
              key={image.id}
              className="image-item" 
              onClick={() => setSelectedImage(image)}
            >
              <img src={image.src} alt={image.title} />
              <span className={`image-number ${selectedImage.id === image.id ? "selected" : ""}`}>{image.id}</span>
            </div>
          ))}
        </div>
        <div className="text-container">
          <h2>{selectedImage.title}</h2>
          <p>{selectedImage.description}</p>
        </div>
      </div>

      <div className="bridal-faq">
        <h2>Custom Tailoring FAQ's</h2>
        <div>
          {contentFaqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <button className="faq-question" onClick={() => toggleFAQ(index)}>
                {faq.question}
                <span className="faq-toggle">{openIndex === index ? "−" : "+"}</span>
              </button>
              {openIndex === index && <p className="faq-answer">{faq.answer}</p>}
            </div>
          ))}
        </div>
      </div>

    </div>
  );
};

export default CustomService;